import React, { useState } from "react";
import { useNavigate } from "react-router-dom/dist";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { IoMdClose } from "react-icons/io";

import { logout } from "../../controllers/accounts/Account"


const LogoutConformationPopup = ({ popUpOpen, togglePopUp }) => {
  const navigate = useNavigate();
  const handleCancel = () => {
    togglePopUp();
  };

  const handleConfirm = async () => {
    const res = await logout();
    if(res.status === true){
      navigate('/');
    } else{
      sessionStorage.clear();
      localStorage.clear();
      navigate('/');
    }
    
  };

  return (
    <Dialog
      open={popUpOpen}
      onClose={togglePopUp}
      maxWidth="md"
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer" style={{padding:"30px"}}>
        <div className="myMainDrawerClass">
          <div>
            <Typography
              variant="h5"
              component="div"
              gutterBottom
              className="myFilterClass"
              style={{marginLeft:"27px"}}
            >
              Confirm
            </Typography>
          </div>
          {/* <div>
            <IconButton onClick={togglePopUp}>
              <IoMdClose />
            </IconButton>
          </div> */}
        </div>
        <Typography
          variant="body1"
          component="div"
          className="my_delete_popup_paragraph"
        >
          <p>Do you want to logout?</p>
        </Typography>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirm} style={{ color: "red" }}>
            Confirm
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default LogoutConformationPopup;
